import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 text-center">
      <p className="font-heading font-black text-6xl text-primary-500">404</p>
      <h1 className="mt-4 font-heading font-bold text-xl text-foreground-950">页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-500 max-w-md">
        你访问的页面不存在或已被移动，不妨回到首页看看最新的资讯内容。
      </p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line" /> 搜索资讯
        </Link>
      </div>
    </div>
  );
}